import { gql } from '__generated__'

export const GET_DEMO_COIN_BALANCE = gql(`
  query getDemoCoinBalance {
    getDemoCoinBalance {
      balance
    }
  }
`)
